/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useVacancyPublicationUrl } from 'domain/recruiting/vacancy/publication/vacancyPublicationRoute';

const VacancyPublicationBreadcrumbs = ({ children }: any) => {
  const { getListUrl } = useVacancyPublicationUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Vacancy Publication" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default VacancyPublicationBreadcrumbs;
